import { render } from "./EmptyProjectGrid.vue?vue&type=template&id=10f3bf38&scoped=true"
import script from "./EmptyProjectGrid.vue?vue&type=script&lang=js"
export * from "./EmptyProjectGrid.vue?vue&type=script&lang=js"

import "./EmptyProjectGrid.vue?vue&type=style&index=0&id=10f3bf38&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10f3bf38"],['__file',"src/scripts/view/portfolio/sections/_helper/EmptyProjectGrid.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "10f3bf38"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('10f3bf38', __exports__)) {
    api.reload('10f3bf38', __exports__)
  }
  
  module.hot.accept("./EmptyProjectGrid.vue?vue&type=template&id=10f3bf38&scoped=true", () => {
    api.rerender('10f3bf38', render)
  })

}


export default __exports__